const BULK_DEPLOY_MODALS = {
  PIPELINE_DIFF: 'PIPELINE_DIFF',
  CONFIRM_BULK_DEPLOY: 'CONFIRM_BULK_DEPLOY',
  DEPLOY_PROGRESS: 'DEPLOY_PROGRESS',
};

export default BULK_DEPLOY_MODALS;
